import { store } from "./store";
import authActions from "./auth/actions";
import { getCurrentUserInfo } from "../helpers/parseHelper";

export default () =>
  new Promise(() => {
    if (localStorage.getItem("token")) getCurrentUserInfo();
    store.dispatch(authActions.checkAuthorization());
  });
